import { CurrencyEnum } from '../interfaces/plan.interface';
import { PlanDetailsModel } from '../interfaces/plan.interface';
import { SUPPORTED_CURRENCIES } from '../config/currencies';

export interface CurrencyDebugInfo {
  userCountry?: string;
  userCurrency: CurrencyEnum;
  planId: string;
  planName: string;
  displayCurrency?: CurrencyEnum;
  displayCost?: number;
  displayStripePlanId?: string;
  availableCurrencies: CurrencyEnum[];
  hasCurrencyPricing: boolean;
}

/**
 * Debug utility to check currency configuration for a plan
 */
export const debugPlanCurrency = (
  plan: PlanDetailsModel,
  userCountry?: string,
  userCurrency?: CurrencyEnum
): CurrencyDebugInfo => {
  const currency = userCurrency || CurrencyEnum.USD;
  const availableCurrencies = plan.pricing?.map(p => p.currency) || [CurrencyEnum.USD];
  
  return {
    userCountry,
    userCurrency: currency,
    planId: plan.id,
    planName: plan.name,
    displayCurrency: plan.displayCurrency,
    displayCost: plan.displayCost,
    displayStripePlanId: plan.displayStripePlanId,
    availableCurrencies,
    hasCurrencyPricing: !!(plan.pricing && plan.pricing.length > 0)
  };
};

/**
 * Log currency debug information
 */
export const logCurrencyDebug = (debugInfo: CurrencyDebugInfo) => {
  console.group(`Currency Debug - Plan: ${debugInfo.planName}`);
  console.log('User Country:', debugInfo.userCountry);
  console.log('User Currency:', debugInfo.userCurrency);
  console.log('Display Currency:', debugInfo.displayCurrency);
  console.log('Display Cost:', debugInfo.displayCost);
  console.log('Display Stripe Plan ID:', debugInfo.displayStripePlanId);
  console.log('Available Currencies:', debugInfo.availableCurrencies);
  console.log('Has Currency Pricing:', debugInfo.hasCurrencyPricing);
  console.groupEnd();
};

/**
 * Validate currency configuration
 */
export const validateCurrencyConfig = (debugInfo: CurrencyDebugInfo): string[] => {
  const errors: string[] = [];
  
  if (!debugInfo.hasCurrencyPricing) {
    errors.push('Plan has no multi-currency pricing configured');
  }
  
  if (debugInfo.displayCurrency && !debugInfo.availableCurrencies.includes(debugInfo.displayCurrency)) {
    errors.push(`Display currency ${debugInfo.displayCurrency} not available in plan pricing`);
  }
  
  if (debugInfo.displayCurrency && debugInfo.displayCost === undefined) {
    errors.push('Display currency set but no display cost provided');
  }
  
  if (debugInfo.displayCurrency && !debugInfo.displayStripePlanId) {
    errors.push('Display currency set but no Stripe plan ID provided');
  }
  
  return errors;
}; 